<div class="page-container">
    <div>
        <div *ngIf="companyData" class="category-title">Company name: {{companyData.name}}</div>
        <div *ngIf="companyData" class="category-title">Company address: {{companyData.address}}</div>
        <div *ngIf="companyData" class="category-title">Company contact name: {{companyData.contactName}}</div>
        <div *ngIf="companyData" class="category-title">Company contact email: {{companyData.email}}</div>
        <div *ngIf="companyData" class="category-title">Company contact phone: {{companyData.phone}}</div>
    </div>
    <div>
        <div *ngIf="userData" class="category-title">Current user name: {{userData.name}}</div>
        <div *ngIf="userData" class="category-title">Current user email: {{userData.email}}</div>
        <div *ngIf="userData" class="category-title">Current user phone: {{userData.phone}}</div>
        <div *ngIf="userData" class="category-title">Current user role: {{userData.role}}</div>
        <div *ngIf="userData" class="category-title">Current user notifications enabled: {{userData.notificationsEnabled}}</div>
        <!-- <div *ngIf="userData && userData.notificationsEnabled">
            <div *ngIf="userData.notificationsPlatforms.email" class="category-title">Current user notifications by email: {{userData.notificationsPlatforms.email}}</div>
            <div *ngIf="userData.notificationsPlatforms.sms" class="category-title">Current user notifications by SMS: {{userData.notificationsPlatforms.sms}}</div>
            <div *ngIf="userData.notificationsPlatforms.push" class="category-title">Current user notifications by push: {{userData.notificationsPlatforms.push}}</div>
        </div> -->
        
    </div>
    
</div>

